import $ from 'jquery';

import AlerterView from 'chairisher/view/alerter';
import ProductModel from 'chairisher/model/product';

import pinterestLoader from 'chairisher/thirdparty/pinterest';

import { TrackingSocialMediaPlatform } from 'chairisher/util/analytics';
import {
    logSocialShareAbandonEvent,
    logSocialShareErrorEvent,
    logSocialShareEvent,
} from 'chairisher/analytics/product';
import { isDesktopUserAgent } from 'chairisher/util/mediaquery';
import { getProductObjectById } from 'chairisher/context/product';

pinterestLoader().catch((e) => {
    // in case pinterest doesn't load, remove it as a sharing option
    $('.js-pinterest-share-container').remove();
    throw e;
});

const $shareBtn = $('.js-share-btn');

/**
 * Returns sharing context for a social share action.
 *
 * Finds the relevant share button and product data for the item associated with the event target.
 *
 * @param {Event} e - The event object from the share/copy/email/pinterest button click.
 * @returns {Object} An object containing:
 *   - {$btn} jQuery object for the button that triggered the event
 *   - {string} shareUrl - The URL to share for the product
 *   - {ProductModel} product - The product model instance for analytics
 */
function getProductShareContext(e) {
    const $btn = $(e.currentTarget);
    const $contextShareBtn = $btn.closest('.social-share-container').find($shareBtn);
    const productId = $contextShareBtn.data('product-id');
    return {
        $btn,
        shareUrl: $contextShareBtn.data('url'),
        product: new ProductModel(getProductObjectById(productId)),
    };
}

const SocialShare = {
    /**
     * Binds social share buttons and links
     */
    bind() {
        // EMAIL
        $('.js-email-share').on('click', (e) => {
            e.preventDefault();
            const { shareUrl, product, $btn } = getProductShareContext(e);

            window.location.href = `mailto:?subject=${encodeURIComponent(
                $btn.data('subject'),
            )}&body=${encodeURIComponent(shareUrl)}`;

            logSocialShareEvent(product, TrackingSocialMediaPlatform.EMAIL, shareUrl);
        });

        // PINTEREST
        $('.js-pinterest-share').on('click', (e) => {
            const { shareUrl, product } = getProductShareContext(e);
            logSocialShareEvent(product, TrackingSocialMediaPlatform.PINTEREST, shareUrl);
        });

        // COPY & SHARE
        if (navigator.share && !isDesktopUserAgent()) {
            $shareBtn.on('click', (e) => {
                const { shareUrl, product, $btn } = getProductShareContext(e);

                navigator
                    .share({
                        title: $btn.data('title'),
                        url: shareUrl,
                    })
                    .then(
                        () => {
                            logSocialShareEvent(product, TrackingSocialMediaPlatform.DEVICE_SHARE, shareUrl);
                        },
                        () => {
                            logSocialShareAbandonEvent(product, TrackingSocialMediaPlatform.DEVICE_SHARE, shareUrl);
                        },
                    );
            });
        } else {
            const $socialMenu = $('.js-social-menu');
            $shareBtn.on('mouseenter', () => $socialMenu.removeClass('hidden'));

            $('.js-copy-share').on('click', (e) => {
                const { shareUrl, product, $btn } = getProductShareContext(e);
                const $btnText = $btn.find('.js-copy-btn-text');

                navigator.clipboard.writeText(shareUrl).then(
                    () => {
                        $btnText.text($btn.data('clicked-text'));

                        setTimeout(() => {
                            $socialMenu.addClass('hidden');
                            $btnText.text($btn.data('text'));
                        }, 1000);

                        logSocialShareEvent(product, TrackingSocialMediaPlatform.LINK_COPY, shareUrl);
                    },
                    () => {
                        AlerterView.error();
                        logSocialShareErrorEvent(product, TrackingSocialMediaPlatform.LINK_COPY, shareUrl);
                    },
                );
            });
        }
    },
};

export default SocialShare;
